import React, { useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowDecisionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowDecisionModal";
import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../../src/api/caseStages";
import { useParams } from "react-router-dom";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";


export const AcceptCreatedCase: React.FC<{
  next_stage: CaseStageEnum
}> = ({
  next_stage
}) => {
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleAccept = async () => {
    if (!caseId) return;

    try {
      setIsLoading(true);

      const request: AddStageRequest = {
        stage: next_stage,
        source_action: CaseStageAction.ACCEPT_CREATED_CASE,
      };

      await dispatch(updateCaseStage({caseId, request})).unwrap();

      showSuccessToast("Case accepted successfully");

      setIsModalOpen(false);
    } catch (error) {
      showErrorToast("Failed to accept case");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AcceptButton
        label="Accept"
        onClick={handleOpen}
      />

      <StageWorkflowDecisionModal
        isOpen={isModalOpen}
        variant="accept"
        title="Accept Case Review"
        subtitle="Are you sure you want to accept this case?"
        primaryButtonLabel="Accept"
        onPrimaryAction={handleAccept}
        onClose={handleClose}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};
